import { useState,useEffect } from "react";
import { storeUserTimeZone } from "../../helpers/LocalStorageUtility";
import UserContext from "./UserContext";
import { APIs, API_BASE_URL, AuthRoutes, roleAccess, commonAllowedRolesAccess, USERTYPES, NonAuthRoutes, SERVICEURL, SHARED_SERVICEURL } from "../../constants/Constants";
import axios from "axios";
import Moment from "moment";
import { encryptData } from "../../helpers/RSAUtility";
import axiosInterceptor from "../../helpers/Interceptor";
import { v4 as uuidv4 } from 'uuid';
import { jwtDecode } from "jwt-decode";
import { getEnv } from '../../helpers/EnvHelper';
import { refreshToken as refreshJwtCookie } from "../../service/RefreshTokenService";
import { setPasswordResetFlags } from "../../helpers/PasswordResetFlags";

axios.defaults.withCredentials = true;

// The login endpoints (signin, 2FA, load-by-username) no longer send every per-user flag; they
// send `features`, the list of the ones that are ON (VAPT: excessive data exposure). Map it back
// to the field names the handlers below have always read, so the context values are unchanged.
// A response without `features` (open-api/authenticate, an older backend) passes through as-is.
const readLoginFlags = (data) => {
  if (!data || !Array.isArray(data.features)) return data ?? {};
  const on = (code) => data.features.includes(code);
  return {
    ...data,
    activeData: on("ACTIVE_DATA"),
    aiRouteToNodeEnabled: on("AI_ROUTE_TO_NODE"),
    showConfirmation: on("ASSIGN_CONFIRMATION"),
    blitzSessionEnabled: on("BLITZ_SESSION"),
    contextSwitchUser: on("CONTEXT_SWITCH"),
    radiologistType: on("EXPERT_RADIOLOGIST") ? 2 : 0,
    exportCsvAllowed: on("EXPORT_CSV"),
    enableLlmReport: on("LLM_REPORT"),
    multipleActiveSessions: on("MULTIPLE_SESSIONS"),
    showPagination: on("PAGINATION"),
    forceReset: on("PASSWORD_EXPIRED"),
    passwordResetAllowed: on("PASSWORD_RESET"),
    redirectOnLogin: on("PASSWORD_RESET_REQUIRED"),
    peerReviewAdmin: on("PEER_REVIEW_ADMIN"),
    peerReviewEvaluator: on("PEER_REVIEW_EVALUATOR"),
    privilegedFirmDoctor: on("PRIVILEGED_DOCTOR"),
    privilegedFirmTechnician: on("PRIVILEGED_TECHNICIAN"),
    qcOpenStudyDisabled: on("QC_OPEN_STUDY_DISABLED"),
    qcOutsourceLogin: on("QC_OUTSOURCE") ? 1 : 0,
    qcReviewer: on("QC_REVIEWER") ? 1 : 0,
    qcSelfLockDisabled: on("QC_SELF_LOCK_DISABLED"),
    routeToNodeEnabled: on("ROUTE_TO_NODE"),
    enableStudyUpload: on("STUDY_UPLOAD"),
    disableSubmit: on("SUBMIT_DISABLED"),
    showViewerTechnician: on("TECHNICIAN_VIEWER"),
    enableReportAndHeaderTemplateConfigurations: on("TEMPLATE_CONFIG"),
    twoFAGlobalFlag: on("TWO_FA"),
  };
};

const UserState = (props) => {

  const queryString = window.location.search;
  // Create a URLSearchParams object
  const urlParams = new URLSearchParams(queryString);

 

  const [contextSwitchUser , setContextSwitchUser] = useState(false);
  const [unautherizedAccessObj, setShowUnauthunautherizedAccessObj] = useState({
    showError:false,
    errorMsg: ""
  });

  const [contextSwitchStudyviewer , setContextSwitchStudyviewer] = useState(false);

  const [userDetail, setUserDetail] = useState({});
  const [token, setToken] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [roles, setRoles] = useState([]);
  const [email, setEmail] = useState("");
  const [showSuccessToast, setSuccessToast] = useState(false);
  const [qcReviewer, setQcReviewer] = useState();
  const [qcOutsourceLogin, setQcOutsourceLogin] = useState();
  const [name, setName] = useState("");
  const [firmId, setFirmId] = useState();
  const [firmName, setFirmName] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [lastResetPasswordDate, setLastResetPasswordDate] = useState(null);
  const [passwordExpiresInDays, setPasswordExpiresInDays] = useState(null);
  const [showPasswordExpiryMessage, setShowPasswordExpiryMessage] = useState(false);
  const [daysRemainingForExpiry, setDaysRemainingForExpiry] = useState(0);
  const [editorName, setEditorName] = useState("froala");
  const [userSettings, setUserSettings] = useState(null);
  const [isActiveData, setIsActiveData] = useState(true);
  const [radiologistType, setRadiologistType] = useState(null);
  // OLD: const [enableLlmReport , setEnableLlmReport] = useState(() => localStorage.getItem("enableLlmReport") === "true");
  const [enableLlmReport , setEnableLlmReport] = useState(() => sessionStorage.getItem("enableLlmReport") === "true");
  const [twoFAGlobalEnable , setTwoFAGlobalEnable] = useState(false);
  const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(false);
  const [customerSupportNumber,setcustomerSupportNumber]=useState("");
  const [privilegedFirmDoctor , setPrivilegedFirmDoctor] = useState(false);
  const [peerReviewAdmin, setPeerReviewAdmin] = useState(false);
  const [peerReviewEvaluator, setPeedReviewEvaluator] = useState(false);
  const [resetPasswordAllowed,setResetPasswordAllowed]=useState(false);
  const [forcedLogoutAllowed,setForcedLogoutAllowed]=useState(false);
  const [enableStudyUpload, setEnableStudyUpload] = useState(false);
  const [showSavedReport, setShowSavedReport] = useState(false);
  const [showAiResults, setShowAiResults] = useState(false);
  const [ exportCsvAllowed, setExportCsvAllowed ] = useState(false);
  const [ disableSubmitforResident, setDisableSubmitforResident ] = useState(false);
  const [ typistAllowSubmit, setTypistAllowSubmit ] = useState(true);
  const [ multipleActiveSessions, setMultipleActiveSessions ] = useState(false);
  const [ blitzSessionEnabled, setBlitzSessionEnabled ] = useState(false);
  const [ routeToNodeEnabled, setRouteToNodeEnabled ] = useState(false);
  const [ aiRouteToNodeEnabled, setAiRouteToNodeEnabled ] = useState(false);
  const [ qcSelfLockDisabled, setQcSelfLockDisabled ] = useState(false);
  const [ qcOpenStudyDisabled, setQcOpenStudyDisabled ] = useState(false);
  const [ userTimeZone, setUserTimeZone ] = useState(null);
  const [enableReportAndHeaderTemplateConfigurations, setEnableReportAndHeaderTemplateConfigurations] = useState(false);
  const [ priviledgedFirmTechnician, setPriviledgedFirmTechnician ] = useState(false);
  const [ showViewerTechnician, setShowViewerTechnician ] = useState(false);
  const [ showPagination, setShowPagination ] = useState(false);
  const [defaultCountry, setDefaultCountry] = useState("in");
  const [priorityLabels, setPriorityLabels] = useState(null);

  // REMOVED: the "md" machine id. It was sent as X-machineId on every request, but the
  // backend only ever printed it in a log line (AuthController.logJWTInfo /
  // JWTAuthorizationFilter.logJWTInfo) - it was never stored, and never used for
  // authorization, session tracking or multi-session detection. Device identity actually
  // comes from the server side: RefreshTokenService sets device_info from the User-Agent
  // and ip_address alongside it. Dropping it removes the last client-generated id from
  // localStorage; the only loss is correlating log lines across separate logins.
  // OLD:
  // const MACHINE_ID_KEY = "md";
  // const getMachineId = () => {
  //   let machineId = localStorage.getItem(MACHINE_ID_KEY);
  //   if (!machineId) {
  //       machineId = uuidv4();
  //       localStorage.setItem(MACHINE_ID_KEY, machineId);
  //   }
  //   return machineId;
  // };

  const signin = async (username, password) => {
    // NEW (VAPT): a new login starts with no pending reset until its response says otherwise.
    setPasswordResetFlags(false, false);
    try {

      // OLD: const machineId = getMachineId();
      const response = await axios.post(
        API_BASE_URL + "auth/signin",
        {
          // const response = await axios.post("https://enl81exnk1zih.x.pipedream.net/",{
          username: username,
          password: password,
        },
        {
          // withCredentials: true,
          // OLD: "X-machineId":machineId  (see the removal note above)
          headers: { "Content-Type": "application/json" },
          // credentials: 'include'
        }
      );

      console.log("--- User State Response -----", response);
      // --- NEW: persist 2FA / OTP channel info returned by server (if any)
      try {
        const respData = (response && response.data && response.data.data) ? response.data.data : null;
        // The backend sends otpGenerateDto in data for Pending (2FA) case:
        // { email, emailSent, whatsappSent, whatsappNumber }
        if (respData) {
          // for password reset / 2FA flows we want to persist returned masked contacts
          if (respData.email) {
            // For generic flows backend returns "email" (masked); store as forgotPassword or 2fa as needed
            // We'll store both keys so components can read the appropriate one
            sessionStorage.setItem("forgotPasswordEmail", respData.email);
            sessionStorage.setItem("2faEmail", respData.email);
          }
          if (respData.whatsappNumber) {
            sessionStorage.setItem("forgotPasswordWhatsApp", respData.whatsappNumber);
            sessionStorage.setItem("2faWhatsApp", respData.whatsappNumber);
          }
          if (typeof respData.emailSent !== "undefined") {
            sessionStorage.setItem("2faEmailSent", respData.emailSent.toString());
            sessionStorage.setItem("forgotPasswordEmailSent", respData.emailSent.toString());
          }
          if (typeof respData.whatsappSent !== "undefined") {
            sessionStorage.setItem("2faWhatsappSent", respData.whatsappSent.toString());
            sessionStorage.setItem("forgotPasswordWhatsappSent", respData.whatsappSent.toString());
          }
        }
      } catch (e) {
        // swallow errors — non-critical
        console.debug("Could not persist OTP channel info from signin:", e);
      }

      if(response.data.result !== "Pending"){
        const data = readLoginFlags(response.data.data);
        setToken(data.accessToken);

        // ✅ Decode the JWT to extract roles and username
        const decoded = jwtDecode(data.token);

        // Assuming backend added "username" and "roles" claims
        const roles = decoded.roles || [];
        const usernameFromToken = decoded.username || "";

        // ✅ Set roles and username from token
        setRoles(roles);
        setUsername(usernameFromToken);

        setUserId(data.id);
        // setUsername(response.data.data.username);
        setEmail(data.email);
        // setRoles(response.data.data.roles);
        setcustomerSupportNumber(data.customerSupportNumber);
        setPrivilegedFirmDoctor(data.privilegedFirmDoctor);
        setPriviledgedFirmTechnician(data.privilegedFirmTechnician);
        setShowViewerTechnician(data.showViewerTechnician);
        setShowPagination(data.showPagination);
        setPeerReviewAdmin(data.peerReviewAdmin);
        setPeedReviewEvaluator(data.peerReviewEvaluator);
        setResetPasswordAllowed(data.passwordResetAllowed);
        setForcedLogoutAllowed(data.forcedLogoutAllowed);
        setExportCsvAllowed(data.exportCsvAllowed);
        setEnableStudyUpload(data.enableStudyUpload);
        setShowAiResults(data.showAiResults);
        setShowSavedReport(data.showSavedReport);
        setDisableSubmitforResident(data?.disableSubmit);
        setTypistAllowSubmit(data?.allowSubmit ?? true);
        setFirmId(data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : data.activeData);
        setEnableLlmReport(data.enableLlmReport);
        // OLD: localStorage.setItem("enableLlmReport", data.enableLlmReport ? "true" : "false");
        sessionStorage.setItem("enableLlmReport", data.enableLlmReport ? "true" : "false");
        setEnableReportAndHeaderTemplateConfigurations(data.enableReportAndHeaderTemplateConfigurations);
        if(data?.firmName != undefined && data?.firmName != null){
          setFirmName(data.firmName);
        }
        setQcReviewer(data.qcReviewer);
        setQcOutsourceLogin(data.qcOutsourceLogin);
        // OLD:
        // setName(
        //   response.data.data.name == undefined
        //     ? username
        //     : response.data.data.name
        // );
        // NEW (vapt): prefer the display name from the SIGNED token
        setName(
          decoded.name
            ? decoded.name
            : (data.name == undefined ? username : data.name)
        );
        setShowConfirmation(data.showConfirmation);
        setLastResetPasswordDate(data.lastResetPasswordDate);
        setPasswordExpiresInDays(data.passwordExpiresInDays ?? null);
        setBlitzSessionEnabled(data?.blitzSessionEnabled);
        setQcSelfLockDisabled(data?.qcSelfLockDisabled);
        setQcOpenStudyDisabled(data?.qcOpenStudyDisabled);
        setRouteToNodeEnabled(data?.routeToNodeEnabled);
        setAiRouteToNodeEnabled(data?.aiRouteToNodeEnabled);
        if(data?.userSettings?.length > 6 && data?.userSettings != ""){
          const parsedSettings = JSON.parse(data.userSettings);
          setUserSettings(parsedSettings);
          // OLD: if (parsedSettings?.theme) {
          // OLD:   localStorage.setItem("theme", parsedSettings.theme);
          // OLD: }
        }
        if (
          data.editorName != undefined &&
          data.editorName != null
        ) {
          setEditorName(data.editorName);
        } else {
          setEditorName("ckeditor");
        }

        setAuthenticated(true);
        // OLD: localStorage.setItem("hasSession", "1");
        setMultipleActiveSessions(data.multipleActiveSessions);
        setUserTimeZone(data.userTimeZone);
        // VAPT: the timezone moved from localStorage to sessionStorage, so it no longer
        // outlives the tab. sessionStorage starts EMPTY in every new tab, so every login
        // path must write it - see the matching writes in signin2, loadByUsername and
        // authenticate2FAOTP. Previously only this one did, and localStorage persisting
        // across reloads hid that gap.
        // OLD: localStorage.setItem("userTimeZone", data.userTimeZone);
        storeUserTimeZone(data.userTimeZone);
        // localStorage.setItem("refreshToken", response.data.data.refreshToken);
        // localStorage.setItem("username", response.data.data.username);
        // OLD: localStorage.setItem("forceReset", data.forceReset);
        // OLD: localStorage.setItem(
        // OLD:   "redirectOnLogin",
        // OLD:   data.redirectOnLogin
        // OLD: );
        // NEW (VAPT): kept in memory; the backend remembers them in an HttpOnly cookie.
        setPasswordResetFlags(data.forceReset, data.redirectOnLogin);
      }
      return response;
    } catch (error) {
      return error.response ?? { status: 0, data: { message: "NETWORK_ERROR" } };
    }
  };


  const signin2 = async (username, password) => {
    // NEW (VAPT): a new login starts with no pending reset until its response says otherwise.
    setPasswordResetFlags(false, false);
    try {

      // OLD: const machineId = getMachineId();
      // OLD: console.log("Machine id- "+machineId);
      const response = await axios.post(
        "https://augmento-demo.deeptek.ai:8002/" + "auth/signin",
        {
          // const response = await axios.post("https://enl81exnk1zih.x.pipedream.net/",{
          username: username,
          password: password,
        },
        {
          // withCredentials: true,
          // OLD: "X-machineId":machineId  (see the removal note above)
          headers: { "Content-Type": "application/json" },
          // credentials: 'include'
        }
      );

      console.log("--- User State Response -----", response);
      if(response.data.result !== "Pending"){
        const data = readLoginFlags(response.data.data);
        setToken(data.accessToken);
        // NEW (vapt): derive role & username from the SIGNED token, not the plaintext
        const decoded = data.token ? jwtDecode(data.token) : {};
        setUserId(data.id);
        // OLD: setUsername(response.data.data.username);
        setUsername(decoded.username || "");
        setEmail(data.email);
        // OLD: setRoles(response.data.data.roles);
        setRoles(decoded.roles || []);
        setcustomerSupportNumber(data.customerSupportNumber);
        setPrivilegedFirmDoctor(data.privilegedFirmDoctor);
        setPriviledgedFirmTechnician(data.privilegedFirmTechnician);
        setShowViewerTechnician(data.showViewerTechnician);
        setShowPagination(data.showPagination);
        setPeerReviewAdmin(data.peerReviewAdmin);
        setPeedReviewEvaluator(data.peerReviewEvaluator);
        setResetPasswordAllowed(data.passwordResetAllowed);
        setForcedLogoutAllowed(data.forcedLogoutAllowed);
        setExportCsvAllowed(data.exportCsvAllowed);
        setEnableStudyUpload(data.enableStudyUpload);
        setShowAiResults(data.showAiResults);
        setShowSavedReport(data.showSavedReport);
        setFirmId(data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : data.activeData);
        setEnableReportAndHeaderTemplateConfigurations(data.enableReportAndHeaderTemplateConfigurations);
        if(data?.firmName != undefined && data?.firmName != null){
          setFirmName(data.firmName);
        }
        setQcReviewer(data.qcReviewer);
        setQcOutsourceLogin(data.qcOutsourceLogin);
        // OLD:
        // setName(
        //   response.data.data.name == undefined
        //     ? username
        //     : response.data.data.name
        // );
        // NEW (vapt): prefer the display name from the SIGNED token
        setName(
          decoded.name
            ? decoded.name
            : (data.name == undefined ? username : data.name)
        );
        setShowConfirmation(data.showConfirmation);
        setLastResetPasswordDate(data.lastResetPasswordDate);
        setPasswordExpiresInDays(data.passwordExpiresInDays ?? null);
        setBlitzSessionEnabled(data?.blitzSessionEnabled);
        setQcSelfLockDisabled(data?.qcSelfLockDisabled);
        setQcOpenStudyDisabled(data?.qcOpenStudyDisabled);
        setRouteToNodeEnabled(data?.routeToNodeEnabled);
        setAiRouteToNodeEnabled(data?.aiRouteToNodeEnabled);
        if(data?.userSettings?.length > 6 && data?.userSettings != ""){
          const parsedSettings = JSON.parse(data.userSettings);
          setUserSettings(parsedSettings);
          // OLD: if (parsedSettings?.theme) {
          // OLD:   localStorage.setItem("theme", parsedSettings.theme);
          // OLD: }
        }
        if (
          data.editorName != undefined &&
          data.editorName != null
        ) {
          setEditorName(data.editorName);
        } else {
          setEditorName("ckeditor");
        }

        setAuthenticated(true);
        // OLD: localStorage.setItem("hasSession", "1");
        setMultipleActiveSessions(data.multipleActiveSessions);
        // NEW: this path never set the timezone. It was masked by localStorage carrying the
        // value over from an earlier signin; with sessionStorage there is nothing to carry.
        setUserTimeZone(data.userTimeZone);
        storeUserTimeZone(data.userTimeZone);
        // localStorage.setItem("refreshToken", response.data.data.refreshToken);
        // localStorage.setItem("username", response.data.data.username);
        // OLD: localStorage.setItem("forceReset", data.forceReset);
        // OLD: localStorage.setItem(
        // OLD:   "redirectOnLogin",
        // OLD:   data.redirectOnLogin
        // OLD: );
        // NEW (VAPT): kept in memory; the backend remembers them in an HttpOnly cookie.
        setPasswordResetFlags(data.forceReset, data.redirectOnLogin);
      }
      return response;
    } catch (error) {
      return error.response;
    }
  };

  const loadByUsername = async () => {
    // OLD: if (!localStorage.getItem("hasSession")) {
    // OLD:   return false;
    // OLD: }
    // NEW: drop the key left behind by older builds.
    localStorage.removeItem("hasSession");
    // NEW (VAPT): same for the old password-reset flags (now an HttpOnly cookie on the server).
    localStorage.removeItem("forceReset");
    localStorage.removeItem("redirectOnLogin");
    try {
      let response = null;
      if(NonAuthRoutes.CONTEXTSWITCHSTUDYLIST === window.location.pathname){

         // Get a specific query parameter
        const clientId = urlParams.get('clientId');
        const secretKey = urlParams.get('secretKey');
        const patientId = urlParams.get('patientId');

        response =  await axiosInterceptor.post(
          API_BASE_URL + SHARED_SERVICEURL + "/open-api/authenticate" ,{
            data: {
              clientId: clientId,
              secretKey: secretKey,
              patientId: patientId
          
            },
            
          }
        );
        
        if(response.status == 200 && response.data.result=="FAILURE"){
          setShowUnauthunautherizedAccessObj (()=>{
            const newItem = {...unautherizedAccessObj};
            newItem.showError = true;
            newItem.errorMsg = response.data.message;
            return newItem;
            });
        }
        setContextSwitchUser(true);
        
      }else if(NonAuthRoutes.CONTEXTSWITCHSTUDYVIEWER === window.location.pathname){
            // Get a specific query parameter
            const clientId = urlParams.get('clientId');
            const secretKey = urlParams.get('secretKey');
            const studyId = urlParams.get('studyId');

            response =  await axiosInterceptor.post(
              API_BASE_URL + SHARED_SERVICEURL + "/open-api/authenticate" ,{
                data: {
                  clientId: clientId,
                  secretKey: secretKey,
                  studyId: studyId
              
                },
                
              }
            );
            if(response.status == 200 && response.data.result=="FAILURE"){
              setShowUnauthunautherizedAccessObj (()=>{
                const newItem = {...unautherizedAccessObj};
                newItem.showError = true;
                newItem.errorMsg = response.data.message;
                return newItem;
                });
            }
            setContextSwitchUser(true);
            setContextSwitchStudyviewer(true);
      }
      else{
        
         response = await axiosInterceptor.post(
          API_BASE_URL + APIs.LOADUSERDATA
        );
      }
      // console.log("User data response ", response);
      if (response.status === 200 && response.data.result === "Success") {
        const data = readLoginFlags(response.data.data);
        // console.log("--- User State Response -----", response);
        
        // ✅ Decode the JWT to extract roles and username
        const decoded = jwtDecode(data.token);

        // Assuming backend added "username" and "roles" claims
        const roles = decoded.roles || [];
        const usernameFromToken = decoded.username || "";

        // ✅ Set roles and username from token
        setRoles(roles);
        setUsername(usernameFromToken);

        setUserId(data.id);
        // setUsername(response.data.data.username);
        setEmail(data.email);
        // setRoles(response.data.data.roles);
        setAuthenticated(true);
        // OLD: localStorage.setItem("hasSession", "1");
        // NEW (VAPT): the server reports this login's pending password reset (from its
        // HttpOnly pwd-reset-pending cookie); Router redirects on it. Replaces localStorage.
        setPasswordResetFlags(data.forceReset, data.redirectOnLogin);
        // NEW: loadByUsername runs on every page load / new tab, so this is the write that
        // repopulates sessionStorage after a refresh. Without it a reload would silently
        // fall back to the browser's own timezone.
        setUserTimeZone(data.userTimeZone);
        storeUserTimeZone(data.userTimeZone);
        setContextSwitchUser(data.contextSwitchUser);
        // OLD:
        // setName(
        //   response.data.data.name == undefined
        //     ? username
        //     : response.data.data.name
        // );
        // NEW (vapt): prefer the display name from the SIGNED token 
        setName(
          decoded.name
            ? decoded.name
            : (data.name == undefined ? username : data.name)
        );
        if(data?.userSettings?.length > 6 && data?.userSettings != ""){
          const parsedSettings = JSON.parse(data.userSettings);
          setUserSettings(parsedSettings);
          // OLD: if (parsedSettings?.theme) {
          // OLD:   localStorage.setItem("theme", parsedSettings.theme);
          // OLD: }
        }
        setFirmId(data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : data.activeData);
        if(data?.firmName != undefined && data?.firmName != null){
          setFirmName(data.firmName);
        }
        setEditorName("froala");  
        setQcReviewer(data.qcReviewer);
        setQcOutsourceLogin(data.qcOutsourceLogin);
        setShowConfirmation(data.showConfirmation);
        setLastResetPasswordDate(data.lastResetPasswordDate);
        setPasswordExpiresInDays(data.passwordExpiresInDays ?? null);
        setRadiologistType(data.radiologistType);
        setEnableLlmReport(data?.enableLlmReport);
        // OLD: localStorage.setItem("enableLlmReport", data?.enableLlmReport ? "true" : "false");
        sessionStorage.setItem("enableLlmReport", data?.enableLlmReport ? "true" : "false");
        setTwoFAGlobalEnable(data?.twoFAGlobalFlag);
        setcustomerSupportNumber(data.customerSupportNumber);
        setPrivilegedFirmDoctor(data?.privilegedFirmDoctor);
        setPriviledgedFirmTechnician(data?.privilegedFirmTechnician);
        setShowViewerTechnician(data?.showViewerTechnician);
        setShowPagination(data?.showPagination);
        setPeerReviewAdmin(data?.peerReviewAdmin);
        setPeedReviewEvaluator(data?.peerReviewEvaluator);
        setResetPasswordAllowed(data?.passwordResetAllowed);
        setForcedLogoutAllowed(data?.forcedLogoutAllowed);
        setExportCsvAllowed(data?.exportCsvAllowed);
        setEnableStudyUpload(data?.enableStudyUpload); 
        setShowAiResults(data?.showAiResults);
        setShowSavedReport(data?.showSavedReport);
        setDisableSubmitforResident(data?.disableSubmit);
        setTypistAllowSubmit(data?.allowSubmit ?? true);
        setBlitzSessionEnabled(data?.blitzSessionEnabled);
        setQcSelfLockDisabled(data?.qcSelfLockDisabled);
        setQcOpenStudyDisabled(data?.qcOpenStudyDisabled);
        setRouteToNodeEnabled(data?.routeToNodeEnabled);
        setAiRouteToNodeEnabled(data?.aiRouteToNodeEnabled);
        setEnableReportAndHeaderTemplateConfigurations(data?.enableReportAndHeaderTemplateConfigurations);
        return true;
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        // OLD: localStorage.removeItem("hasSession");
      } else {
        console.error("loadByUsername failed unexpectedly", error);
      }
      return false;
    }
  };

  const authenticate2FAOTP = async (username, otp) => {
    // NEW (VAPT): a new login starts with no pending reset until its response says otherwise.
    setPasswordResetFlags(false, false);
    try {
      const response = await axios.post(API_BASE_URL + APIs.AUTHENTICA2FATEOTP, {
        data: {
          twoFaAuth: {
            username,
            otp,
          },
        },
      });
      console.log(response);
      const data = readLoginFlags(response.data.data);

      setToken(data.accessToken);
        // NEW (vapt): derive role & username from the SIGNED token, not the plaintext
        const decoded = data.token ? jwtDecode(data.token) : {};
        setUserId(data.id);
        // OLD: setUsername(response.data.data.username);
        setUsername(decoded.username || "");
        setEmail(data.email);
        // OLD: setRoles(response.data.data.roles);
        setRoles(decoded.roles || []);
        setFirmId(data.firmId);
        setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : data.activeData);
        setEnableLlmReport(data.enableLlmReport);
        // OLD: localStorage.setItem("enableLlmReport", data.enableLlmReport ? "true" : "false");
        sessionStorage.setItem("enableLlmReport", data.enableLlmReport ? "true" : "false");
        setEnableReportAndHeaderTemplateConfigurations(data.enableReportAndHeaderTemplateConfigurations);
        if(data?.firmName != undefined && data?.firmName != null){
          setFirmName(data.firmName);
        }
        setQcReviewer(data.qcReviewer);
        setQcOutsourceLogin(data.qcOutsourceLogin);
        // OLD:
        // setName(
        //   response.data.data.name == undefined
        //     ? username
        //     : response.data.data.name
        // );
        // NEW (vapt): prefer the display name from the SIGNED token
        setName(
          decoded.name
            ? decoded.name
            : (data.name == undefined ? username : data.name)
        );
        setShowConfirmation(data.showConfirmation);
        setLastResetPasswordDate(data.lastResetPasswordDate);
        setPasswordExpiresInDays(data.passwordExpiresInDays ?? null);
        if(data?.userSettings?.length > 6 && data?.userSettings != ""){
          const parsedSettings = JSON.parse(data.userSettings);
          setUserSettings(parsedSettings);
          // OLD: if (parsedSettings?.theme) {
          // OLD:   localStorage.setItem("theme", parsedSettings.theme);
          // OLD: }
        }
        if (
          data.editorName != undefined &&
          data.editorName != null
        ) {
          setEditorName(data.editorName);
        } else {
          setEditorName("ckeditor");
        }

        setAuthenticated(true);
        // OLD: localStorage.setItem("hasSession", "1");
        // NEW: the 2FA login path never set the timezone either. This is the one users hit
        // most after the logout-clearing change, so without it their timestamps would render
        // in the browser timezone rather than their configured one.
        setUserTimeZone(data.userTimeZone);
        storeUserTimeZone(data.userTimeZone);
        // localStorage.setItem("refreshToken", response.data.data.refreshToken);
        // localStorage.setItem("username", response.data.data.username);
        // OLD: localStorage.setItem("forceReset", data.forceReset);
        // OLD: localStorage.setItem(
        // OLD:   "redirectOnLogin",
        // OLD:   data.redirectOnLogin
        // OLD: );
        // NEW (VAPT): kept in memory; the backend remembers them in an HttpOnly cookie.
        setPasswordResetFlags(data.forceReset, data.redirectOnLogin);

      return response;
    } catch (error) {
      if (error.response.status === 403) {
        // OLD: localStorage.removeItem("hasSession");
        window.location.assign(APIs.REDIRECTLOGOUT);
      }
      else return error.response;
    }
  };

  
  

  const authenticate = async () => {
    return await signin(encryptData("dtfirmadmin"), encryptData("Admin@123"));
  };

  const getConsistentDateFormat = (date) => {
    if (Moment(date).isValid()) {
      return Moment(date).format("DD-MMM-YY hh:mm A");
    } else {
      return "No Date";
    }
  };

  const checkForUserAccess = () => {
    if(getEnv("REACT_APP_HYBRID_MODE") == "true"){
        return;
    }
  try{
    if (window.location.pathname.startsWith(AuthRoutes.USER_DATA_DUMP.replace("/*", ""))) {
      return;
    }
    const nonAuthRoutes = Object.values(NonAuthRoutes);
    if (nonAuthRoutes.includes(window.location.pathname)) {
      return;
    }
    if (roles[0] !== undefined) {
      const allowedRoutes = roleAccess[roles[0]];
      if(commonAllowedRolesAccess.includes(window.location.pathname) 
        || allowedRoutes == undefined 
      || roles[0] === USERTYPES.ADMIN){
        return;
      }
      for (const route of allowedRoutes) {
        const regex = new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');
        //console.log("---Testing for ----",regex.test(window.location.pathname));
        if (regex.test(window.location.pathname)) {
          return;
        }
      }
      if (window.location.pathname !== AuthRoutes.NOT_ALLOWED) {
        window.location.assign(AuthRoutes.NOT_ALLOWED);
      }
    }
  }catch(e){
    console.log("---Exception---",e);
    return;
  }
    
  };

  useEffect(() => {
      checkForUserAccess()
  }, [roles[0],window.location.pathname]);

  useEffect(() => {
    // The backend now sends passwordExpiresInDays (only while the banner should show) instead
    // of lastResetPasswordDate; the date is still used if an older backend sends it.
    let daysDifference = null;
    if (passwordExpiresInDays != null) {
      daysDifference = passwordExpiresInDays;
    } else if (lastResetPasswordDate !== null) {
      const LRPDate = new Date(lastResetPasswordDate);
      const TMPDate = new Date();
      TMPDate.setMonth(TMPDate.getMonth() - 3);
      LRPDate.setHours(0, 0, 0, 0);
      TMPDate.setHours(0, 0, 0, 0);
      daysDifference =
        Math.abs(
          (TMPDate.getTime() - LRPDate.getTime()) / (1000 * 60 * 60 * 24)
        ) + 1;
    }
    if (daysDifference !== null) {
      // OLD: const localStorageField = localStorage.getItem("showPasswordExpiry");
      const localStorageField = sessionStorage.getItem("showPasswordExpiry");
      if (
        daysDifference <= 15 &&
        (localStorageField == null || localStorageField != "false")
      ) {
        setDaysRemainingForExpiry(daysDifference);
        setShowPasswordExpiryMessage(true);
        // OLD: localStorage.setItem("showPasswordExpiry", true);
        sessionStorage.setItem("showPasswordExpiry", true);
      }
    }
  }, [lastResetPasswordDate, passwordExpiresInDays]);

  const handleHidePasswordExpiryMessage = () => {
    setShowPasswordExpiryMessage(false);
    // OLD: localStorage.setItem("showPasswordExpiry", false);
    sessionStorage.setItem("showPasswordExpiry", false);
  };

  // Fetch tenant default country once on mount.
  // Public endpoint (under /rebranding/**), works pre-login — mobile input fields
  // on login / forgot-password screens get the right country too.
  useEffect(() => {
    axios.get(API_BASE_URL + "rebranding/tenant-country", { withCredentials: false })
      .then((res) => {
        const country = res?.data?.defaultCountry;
        if (country) setDefaultCountry(country);
      })
      .catch((err) => {
        console.debug("Could not fetch tenant default country, falling back to 'in'", err);
      });
  }, []);

  // Fetch platform-specific priority labels once on mount.
  // Public endpoint (under /rebranding/**); tenant resolved by backend from host.
  useEffect(() => {
    axios.get(API_BASE_URL + "rebranding/priority-labels", { withCredentials: false })
      .then((res) => {
        const labels = res?.data?.priorityLabels;
        if (Array.isArray(labels) && labels.length > 0) setPriorityLabels(labels);
      })
      .catch((err) => {
        console.debug("Could not fetch priority labels, falling back to defaults", err);
      });
  }, []);

  useEffect(() => {
    // OLD: const reloadPage = localStorage.getItem('reloadPageDataSwitch');
    const reloadPage = sessionStorage.getItem('reloadPageDataSwitch');
    if (reloadPage) {
      // OLD: localStorage.removeItem('reloadPageDataSwitch');
      sessionStorage.removeItem('reloadPageDataSwitch');
      window.location.reload();
    }
  }, [isActiveData]);

  // Proactively refresh the JWT cookie on a timer so it never expires
  // mid-session. Cornerstone's wadors/wadouri XHRs bypass axiosInterceptor,
  // so the interceptor's reactive 403→refresh path doesn't cover image
  // loads — a burst of frame requests hitting an expired cookie would all
  // fail with no recovery. Defaults to every 5 minutes; tune via
  // REACT_APP_JWT_REFRESH_INTERVAL_MS to stay safely under the backend's
  // jwt.expiration.time.min.
  useEffect(() => {
    if (!authenticated) return;
    const configured = parseInt(getEnv("REACT_APP_JWT_REFRESH_INTERVAL_MS"), 10);
    const intervalMs = Number.isFinite(configured) && configured > 0
      ? configured
      : 5 * 60 * 1000;
    const id = setInterval(() => {
      refreshJwtCookie().catch((err) => {
        console.warn("[jwt-refresh] periodic refresh failed", err);
      });
    }, intervalMs);
    return () => clearInterval(id);
  }, [authenticated]);

  return (
    <UserContext.Provider
      value={{
        signin,
        signin2,
        loadByUsername,
        userDetail,
        setUserDetail,
        token,
        authenticate,
        authenticated,
        userId,
        email,
        username,
        roles,
        showSuccessToast,
        setSuccessToast,
        firmId,
        firmName,
        name,
        qcReviewer,
        qcOutsourceLogin,
        showConfirmation,
        editorName,
        getConsistentDateFormat,
        lastResetPasswordDate,
        showPasswordExpiryMessage,
        daysRemainingForExpiry,
        handleHidePasswordExpiryMessage,
        userSettings,
        setUserSettings,
        checkForUserAccess,
        isActiveData,
        setIsActiveData,
        radiologistType,
        unautherizedAccessObj,
        contextSwitchUser,
        contextSwitchStudyviewer,
        enableLlmReport,
        authenticate2FAOTP,
        twoFAGlobalEnable,
        customerSupportNumber,
        privilegedFirmDoctor,
        peerReviewAdmin,
        peerReviewEvaluator,
        resetPasswordAllowed,
        forcedLogoutAllowed,
        disableSubmitforResident,
        typistAllowSubmit,
        multipleActiveSessions, 
        setMultipleActiveSessions,
        blitzSessionEnabled,
        qcSelfLockDisabled,
        qcOpenStudyDisabled,
        routeToNodeEnabled,
        aiRouteToNodeEnabled,
        exportCsvAllowed,
        enableStudyUpload, 
        userTimeZone,
        setUserTimeZone,
        enableReportAndHeaderTemplateConfigurations,
        priviledgedFirmTechnician,
        showViewerTechnician,
        showPagination,
        defaultCountry,
        priorityLabels
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
